import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import ShowForexOrdersData from "./ShowForexOrdersData";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../Login/firebase";
import apiClient from "../../utils/apiClient";
import { w3cwebsocket as WebSocket } from "websocket";
import server from "../../utils/serverConfig";

export default function DashboardLive() {
  const [user] = useAuthState(auth);

  const [liveOrders, setLiveOrders] = useState([]);
  const [positionsOrders, setPositionsOrders] = useState([]);
  const [accountName, setAccountName] = useState();
  const [liveTrade, setLiveTrade] = useState([]);
  const [rejectedOrders, setRejectedOrders] = useState([]);
  const [socket, setSocket] = useState();

  const wsRef = useRef(null);

function convertSymbolToFyersFormat(symbol) {
    try {
        // Safety: non-string or empty
        if (!symbol || typeof symbol !== "string") {
            return symbol;
        }
        if (
            symbol.startsWith("MCX:") ||
            symbol.startsWith("NSE:") ||
            symbol.startsWith("BSE:")
        ) {
            return symbol;
        }

        const symbolSplit = symbol.trim().split(/\s+/);

        if (symbolSplit.length !== 4) {
            return symbol;
        }

        const [underlying, expiryDate, strikePrice, optionType] = symbolSplit;

        if (!["CE", "PE"].includes(optionType)) {
            return symbol;
        }

        if (!expiryDate || expiryDate.length < 3) {
            return symbol;
        }

        const expiryYear = expiryDate.slice(-2);
        const expiryMonth = expiryDate.replace(/\d/g, "");

        return `NSE:${underlying}${expiryYear}${expiryMonth}${strikePrice}${optionType}`;
    } catch (e) {
        console.error(
            `[CRITICAL] Error in convertSymbolToFyersFormat for ${symbol}:`,
            e
        );
        return symbol; // never break UI / WS
    }
}


  const liveOrdersData = () => {
    apiClient
      .get("live_orders_data")
      .then((response) => {
        console.log("Live Orders -", response.data);
        // Before setting liveOrders, convert symbol if needed
        if (Array.isArray(response.data)) {
          response.data.forEach(order => {
            if (order.symbol && !order.symbol.includes("NSE:") && !order.symbol.includes("BSE:")) {
              order.symbol = convertSymbolToFyersFormat(order.symbol);
            }
          });
        }
        setLiveOrders(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const livePoistionsData = () => {
    apiClient
      .get("fyers-positions-data")
      .then((response) => {
        setPositionsOrders(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const liveTradesData = () => {
    apiClient
      .get("live_trades_data")
      .then((response) => {
        console.log("Live Trades data -", response.data);
        
        // Before setting liveOrders, convert symbol if needed
        if (Array.isArray(response.data)) {
          response.data.forEach(trade => {
            if (trade.symbol && !trade.symbol.includes("NSE:")) {
              trade.symbol = convertSymbolToFyersFormat(trade.symbol);
            }
            if(trade.side === 2){
              trade.side = -1; 
            }
          });
        }


        setLiveTrade(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  

  const fetchRejectedOrdersData = () => {
    apiClient
      .get("rejected_orders_data")
      .then((response) => {
        console.log("Rejected Orders -", response.data);

        if (!Array.isArray(response.data)) {
          setRejectedOrders([]);
          return;
        }
        setRejectedOrders(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [allUser, setAllUser] = useState([]);

  const getAccountName = () => {
    apiClient
      .get("fyers-user-mapping")
      .then((response) => {
        const userData = response.data;
        console.log("User Data -", userData);
        const activeAccounts = Array.isArray(userData)
          ? userData.filter(account => account.status === "active")
          : [];
        setAccountName(activeAccounts);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  const getAllAccountUser = () => {
    apiClient
      .get("get-fyers-users")
      .then((response) => {

        console.log("All Users -", response.data);
        setAllUser(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  useEffect(() => {
    getAccountName();
    liveOrdersData();
    livePoistionsData();
    getAllAccountUser();
    liveTradesData();
    fetchRejectedOrdersData()
  }, []);


  const [updating, setUpdating] = useState(false);

  const updateData = () => {
    setUpdating(true);
    const data = {
      secret_key: "cmdev500",
    };

    apiClient
      .post("update-orders", data)
      .then((response) => {
        setUpdating(false);

        if (response.data.message === "updated") {
          liveOrdersData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [liveTradeUpdating, setLiveTradeUpdating] = useState(false);

  const updateLiveTradeData = () => {
    setLiveTradeUpdating(true);
    const data = {
      secret_key: "cmdev500",
    };

    apiClient
      .post("update-trades", data)
      .then((response) => {
        setLiveTradeUpdating(false);
        console.log("response -", response);

        if (response.data.message === "updated") {
          liveTradesData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [livePositionUpdating, setLivePositionUpdating] = useState(false);

  const updateLivePositionsData = () => {
    setLivePositionUpdating(true);
    const data = {
      secret_key: "cmdev500",
    };

    apiClient
      .post("update-positions", data)
      .then((response) => {
        setLivePositionUpdating(false);
        // console.log("response from Positions -", response);

        if (response.data.message === "updated") {
          livePoistionsData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // console.log("Live Trades", liveTrade);
  // console.log("Live positions", positionsOrders);


  useEffect(() => {
    const interval = setInterval(() => {
      // Fetch data every 2 minutes
      console.log("Fetching data every 2 minutes...");
      updateData();
      updateLiveTradeData();
      updateLivePositionsData();
    }, 2 * 60 * 1000); // 2 minutes in milliseconds

    return () => clearInterval(interval); 
  }, []);

   console.log("Account names", accountName);

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full max-h-screen">
        {/* <div className="grid grid-cols-3 gap-4">
          <div className="flex flex-col items-center justify-center  w-full bg-gray-200 rounded-md h-[100px]">
            <h3 className="text-xl font-semibold text-gray-900">Live PNL</h3>
            <p className="text-3xl font-bold text-green-500">+20K</p>
          </div>
          <div className="flex flex-col items-center justify-center  w-full bg-gray-200 rounded-md h-[100px]">
            <h3 className="text-xl font-semibold text-gray-900">
              Position Count
            </h3>
            <p className="text-3xl font-bold text-gray-900">40</p>
          </div>
          <div className="flex flex-col items-center justify-center  w-full bg-gray-200 rounded-md h-[100px]">
            <h3 className="text-xl font-semibold text-gray-900">
              Orders Count
            </h3>
            <p className="text-3xl font-bold text-gray-900">20</p>
          </div>
          
        </div> */}

        <div className="flex flex-col flex-1 ">
          <ShowForexOrdersData
            liveOrders={liveOrders}
            positionsOrders={positionsOrders}
            rejectedOrders={rejectedOrders}
            accountName={accountName}
            allUser={allUser && allUser}
            updateData={updateData}
            updating={updating}
            liveTrade={liveTrade}
            liveTradeUpdating={liveTradeUpdating}
            updateLiveTradeData={updateLiveTradeData}
            livePositionUpdating={livePositionUpdating}
            updateLivePositionsData={updateLivePositionsData}
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
